<script setup lang="ts">
  /**
   * Message list — 03-components/13f-message-list · OSCloud DS 1.1.152
   *
   * The box a register of RECEIVED messages sits in: system notices, sent mail, delivered
   * documents. Its rows are `BfMessageRow`s, each opening the full record in a `BfModal record`.
   *
   * Not a data table (a message is one long subject and a date, not comparable columns), not a
   * record row group (record rows are read-only and never a target), not an accordion (a long
   * message would push the register off screen).
   *
   * The `pager` slot takes a `BfPagination docked` as the box's last line. An empty register
   * puts a `BfEmptyState` in the default slot instead of rows, and no pager.
   */
</script>

<template>
  <div class="message-list">
    <slot />
    <slot name="pager" />
  </div>
</template>

<style scoped lang="scss">
  /* overflow: hidden clips the first and last row's square corners to the radius, and the
     rows' hover marker with them.

     The two custom properties are the data table's cell padding, republished: a docked
     `BfPagination` reads them, and outside a table they would compute to nothing. The
     horizontal value is the row's 20px, so the pager's text lines up with a row's.

     container-type makes the row restack on the width the LIST gets, not the viewport. */
  .message-list {
    --bf-data-table-padding-vertical: 14px;
    --bf-data-table-padding-horizontal: 20px;

    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid var(--bf-line);
    border-radius: var(--bf-r-lg);
    background: var(--bf-white);
    container-type: inline-size;
  }
</style>
